import {
  NetworkError,
  deepCamelCase,
  deepSnakeCase,
  Select,
  searchQueryString,
  intoSnakeCase,
} from '../../../fetchers/_helpers';
import { CommentFields, Comment } from '../../../models/components/schemas/comment/Comment';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type DeleteAlbumVideoCommentFields = readonly string[];

/** Options for DELETE /albums/{album_id}/videos/{video_id}/comments/{comment_id} */
export type DeleteAlbumVideoCommentOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  where: {
    /**
     * The ID of the showcase.
     */
    albumId: number;
    /**
     * The ID of the video.
     */
    videoId: number;
    /**
     * The ID of the comment.
     */
    commentId: number;
  };

  /** Possible query parameters for /albums/{album_id}/videos/{video_id}/comments/{comment_id} */
  query?: {
    /**
     * The hashed password of the password-protected video.
     */
    password?: string;
  };
};

/** Result type for DELETE /albums/{album_id}/videos/{video_id}/comments/{comment_id} */
export type DeleteAlbumVideoCommentResult<Paths extends readonly string[]> = unknown;

/**
 * Delete a video comment
 * This method deletes the specified video comment. The authenticated user must be the owner of the comment.
 */
export async function deleteAlbumVideoComment<Paths extends DeleteAlbumVideoCommentFields>({
  baseUrl,
  where: { albumId, videoId, commentId },
  query,
  ...options
}: DeleteAlbumVideoCommentOptions<Paths>): Promise<DeleteAlbumVideoCommentResult<Paths>> {
  let res = await fetch(
    `${baseUrl}/albums/${albumId}/videos/${videoId}/comments/${commentId}?${searchQueryString(
      query,
    )}`,
    {
      ...options,
      method: 'DELETE',
    },
  );

  if (!res.ok) {
    throw new NetworkError('A network error occurred', res.status, res);
  }

  if (res.status === 204) {
    return null as unknown as DeleteAlbumVideoCommentResult<Paths>;
  }

  if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
    throw new Error('Expected JSON response');
  }

  let json = await res.json();
  return deepCamelCase(json);
}

export type PatchAlbumVideoCommentFields = readonly CommentFields[];

/** Options for PATCH /albums/{album_id}/videos/{video_id}/comments/{comment_id} */
export type PatchAlbumVideoCommentOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  /** Available fields on the response type, application/vnd.vimeo.comment+json */
  select: Paths;
  where: {
    /**
     * The ID of the showcase.
     */
    albumId: number;
    /**
     * The ID of the video.
     */
    videoId: number;
    /**
     * The ID of the comment.
     */
    commentId: number;
  };

  /** Possible query parameters for /albums/{album_id}/videos/{video_id}/comments/{comment_id} */
  query?: {
    /**
     * The hashed password of the password-protected video.
     */
    password?: string;
  };

  /** Data serialized to body for PATCH /albums/{album_id}/videos/{video_id}/comments/{comment_id} */
  variables?: {
    /**
     * The rich comment in JSON stringified form. Either this field or the **text** field is required.
     * @example {"type":"doc","content":[{"type":"paragraph","content":[{"type":"text","text":"I love this!"}]}]}
     */

    richtext?: string;

    /**
     * The comment as plain text. Either this field or the **richtext** field is required.
     * @example I love this!
     */

    text?: string;
  };
};

/** Result type for PATCH /albums/{album_id}/videos/{video_id}/comments/{comment_id} */
export type PatchAlbumVideoCommentResult<Paths extends readonly string[]> = Select<Comment, Paths>;

/**
 * Edit a video comment
 * This method edits the specified video comment. The authenticated user must be the owner of the comment.
 */
export async function patchAlbumVideoComment<Paths extends PatchAlbumVideoCommentFields>({
  baseUrl,
  select,
  variables,
  where: { albumId, videoId, commentId },
  query,
  ...options
}: PatchAlbumVideoCommentOptions<Paths>): Promise<PatchAlbumVideoCommentResult<Paths>> {
  let res = await fetch(
    `${baseUrl}/albums/${albumId}/videos/${videoId}/comments/${commentId}?${searchQueryString(
      query,
    )}&fields=${select.map(intoSnakeCase).join(',')}`,
    {
      ...options,
      method: 'PATCH',
      body: JSON.stringify(deepSnakeCase(variables)),
    },
  );

  if (!res.ok) {
    throw new NetworkError('A network error occurred', res.status, res);
  }

  if (res.status === 204) {
    return null as unknown as PatchAlbumVideoCommentResult<Paths>;
  }

  if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
    throw new Error('Expected JSON response');
  }

  let json = await res.json();
  return deepCamelCase(json);
}
